import React from "react";
import "./app-content.css";

function MapEmbed() {
    return (
        <div className="map-container">
            <iframe
                title="St. Antony's Church Map"
                className="responsive-map"
                loading="lazy"
                allowFullScreen
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3926.152431699956!2d76.336990!3d10.3857505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7f9160db1b0cf%3A0xee6988cf89983317!2sSt.%20Antony's%20Church!5e0!3m2!1sen!2sin!4v1712123456789"
            ></iframe>
        </div>
    );
}

export default MapEmbed;